//
//
//
//
//
//
//
//
//
//

export default {
  name: "MatrixBool",
  props: ["value", "header"],
  methods: {
    input(e) {
			let val
			if (e.target.value === 'true') val = true
			if (e.target.value === 'false') val = false
			if (e.target.value === 'null') val = null
      this.$emit("input", val);
    }
  }
};
